// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusStats {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(6.25rem, 1fr));
  gap: 1rem;
  position: relative;
}
.StatusStats .Stat {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0 0.5rem 0.5rem 0.5rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 1rem;
  background: var(--Foreground);
  cursor: pointer;
}
.StatusStats .Stat .SvgCont {
  background: var(--Foreground);
  width: 2.5rem;
  height: 2.5rem;
  position: relative;
  border-radius: 0 0 0.5rem 0.5rem;
}
.StatusStats .Stat .SvgCont svg {
  min-width: 2.5rem;
  min-height: 2.5rem;
  position: relative;
}
.StatusStats .Stat .SvgCont::after {
  position: absolute;
  content: "";
  width: 1.25rem;
  height: 0.75rem;
  background: transparent;
  right: -1.25rem;
  top: 0;
  z-index: 1;
  border-top-left-radius: 0.75rem;
  box-shadow: -0.75rem 0 0 0 var(--Foreground);
}
.StatusStats .Stat .SvgCont::before {
  position: absolute;
  content: "";
  width: 1.25rem;
  height: 0.75rem;
  background: transparent;
  left: -1.25rem;
  top: 0;
  z-index: 1;
  border-top-right-radius: 0.75rem;
  box-shadow: 0.75rem 0 0 0 var(--Foreground);
}
.StatusStats .Stat .invitation {
  background: #FFF0C9;
}
.StatusStats .Stat .invitation::after {
  box-shadow: -0.75rem 0 0 0 #FFF0C9;
}
.StatusStats .Stat .invitation::before {
  box-shadow: 0.75rem 0 0 0 #FFF0C9;
}
.StatusStats .Stat .accepted {
  background: #FFF4F8;
}
.StatusStats .Stat .accepted::after {
  box-shadow: -0.75rem 0 0 0 #FFF4F8;
}
.StatusStats .Stat .accepted::before {
  box-shadow: 0.75rem 0 0 0 #FFF4F8;
}
.StatusStats .Stat .inprogress {
  background: #DDF7FF;
}
.StatusStats .Stat .inprogress::after {
  box-shadow: -0.75rem 0 0 0 #DDF7FF;
}
.StatusStats .Stat .inprogress::before {
  box-shadow: 0.75rem 0 0 0 #DDF7FF;
}
.StatusStats .Stat .pending {
  background: #F2EBFD;
}
.StatusStats .Stat .pending::after {
  box-shadow: -0.75rem 0 0 0 #F2EBFD;
}
.StatusStats .Stat .pending::before {
  box-shadow: 0.75rem 0 0 0 #F2EBFD;
}
.StatusStats .Stat .completed {
  background: #E9F9EF;
}
.StatusStats .Stat .completed::after {
  box-shadow: -0.75rem 0 0 0 #E9F9EF;
}
.StatusStats .Stat .completed::before {
  box-shadow: 0.75rem 0 0 0 #E9F9EF;
}
.StatusStats .Stat .cancelled {
  background: #FFE7E2;
}
.StatusStats .Stat .cancelled::after {
  box-shadow: -0.75rem 0 0 0 #FFE7E2;
}
.StatusStats .Stat .cancelled::before {
  box-shadow: 0.75rem 0 0 0 #FFE7E2;
}
.StatusStats .Stat .re-initiated {
  background: #DAFFF6;
}
.StatusStats .Stat .re-initiated::after {
  box-shadow: -0.75rem 0 0 0 #DAFFF6;
}
.StatusStats .Stat .re-initiated::before {
  box-shadow: 0.75rem 0 0 0 #DAFFF6;
}
.StatusStats .Stat .Value {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}
.StatusStats .Stat .Value span {
  font-size: clamp(0.75rem, 2vw, 1.5rem);
  font-weight: 700;
  color: var(--TextColor);
  line-height: 100%;
  min-height: clamp(0.75rem, 2vh, 2.25rem);
}
.StatusStats .Stat .Value span:nth-child(2) {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--TextColor);
  white-space: nowrap;
}
.StatusStats .Total {
  background: var(--Background);
  cursor: default;
}
.StatusStats .LoaderContainer {
  position: absolute;
  width: 100%;
  height: 100%;
  min-height: 3.75rem;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(44, 44, 44, 0.3137254902);
  z-index: 3;
}`, "",{"version":3,"sources":["webpack://./src/ClientComponents/StatusStats.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,6DAAA;EACA,SAAA;EACA,kBAAA;AACF;AAAE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,+BAAA;EACA,qCAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AAEJ;AADI;EACE,6BAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,gCAAA;AAGN;AAFM;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;AAIR;AADI;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;EACA,MAAA;EACA,UAAA;EACA,+BAAA;EACA,4CAAA;AAGN;AADI;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,MAAA;EACA,UAAA;EACA,gCAAA;EACA,2CAAA;AAGN;AADI;EACE,mBAAA;AAGN;AADI;EACE,kCAAA;AAGN;AADI;EACE,iCAAA;AAGN;AADI;EACE,mBAAA;AAGN;AADI;EACE,kCAAA;AAGN;AADI;EACE,iCAAA;AAGN;AADI;EACE,mBAAA;AAGN;AADI;EACE,kCAAA;AAGN;AADI;EACE,iCAAA;AAGN;AADI;EACE,mBAAA;AAGN;AADI;EACE,kCAAA;AAGN;AADI;EACE,iCAAA;AAGN;AADI;EACE,mBAAA;AAGN;AADI;EACE,kCAAA;AAGN;AADI;EACE,iCAAA;AAGN;AADI;EACE,mBAAA;AAGN;AADI;EACE,kCAAA;AAGN;AADI;EACE,iCAAA;AAGN;AADI;EACE,mBAAA;AAGN;AADI;EACE,kCAAA;AAGN;AADI;EACE,iCAAA;AAGN;AADI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;AAGN;AAFM;EACE,sCAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,wCAAA;AAIR;AAFM;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAIR;AAAE;EACE,6BAAA;EACA,eAAA;AAEJ;AAAE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,UAAA;AAEJ","sourcesContent":[".StatusStats{\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(6.25rem, 1fr));\n  gap: 1rem;\n  position: relative;\n  .Stat{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.5rem;\n    padding: 0 0.5rem 0.5rem 0.5rem;\n    border: 0.0625rem solid var(--Stroke);\n    border-radius: 1rem;\n    background: var(--Foreground);\n    cursor: pointer;\n    .SvgCont{\n      background: var(--Foreground);\n      width: 2.5rem;\n      height: 2.5rem;\n      position: relative;\n      border-radius: 0 0 0.5rem 0.5rem;\n      svg{\n        min-width: 2.5rem;\n        min-height: 2.5rem;\n        position: relative;\n      }\n    }\n    .SvgCont::after{\n      position: absolute;\n      content: '';\n      width: 1.25rem;\n      height: 0.75rem;\n      background: transparent;\n      right: -1.25rem;\n      top: 0;\n      z-index: 1;\n      border-top-left-radius: 0.75rem;\n      box-shadow: -0.75rem 0 0 0 var(--Foreground);\n    }\n    .SvgCont::before{\n      position: absolute;\n      content: '';\n      width: 1.25rem;\n      height: 0.75rem;\n      background: transparent;\n      left: -1.25rem;\n      top: 0;\n      z-index: 1;\n      border-top-right-radius: 0.75rem;\n      box-shadow: 0.75rem 0 0 0 var(--Foreground);\n    }\n    .invitation{\n      background: #FFF0C9;\n    }\n    .invitation::after{\n      box-shadow: -0.75rem 0 0 0 #FFF0C9;\n    }\n    .invitation::before{\n      box-shadow: 0.75rem 0 0 0 #FFF0C9;\n    }\n    .accepted{\n      background: #FFF4F8;\n    }\n    .accepted::after{\n      box-shadow: -0.75rem 0 0 0 #FFF4F8;\n    }\n    .accepted::before{\n      box-shadow: 0.75rem 0 0 0 #FFF4F8;\n    }\n    .inprogress{\n      background: #DDF7FF;\n    }\n    .inprogress::after{\n      box-shadow: -0.75rem 0 0 0 #DDF7FF;\n    }\n    .inprogress::before{\n      box-shadow: 0.75rem 0 0 0 #DDF7FF;\n    }\n    .pending{\n      background: #F2EBFD;\n    }\n    .pending::after{\n      box-shadow: -0.75rem 0 0 0 #F2EBFD;\n    }\n    .pending::before{\n      box-shadow: 0.75rem 0 0 0 #F2EBFD;\n    }\n    .completed{\n      background: #E9F9EF;\n    }\n    .completed::after{\n      box-shadow: -0.75rem 0 0 0 #E9F9EF;\n    }\n    .completed::before{\n      box-shadow: 0.75rem 0 0 0 #E9F9EF;\n    }\n    .cancelled{\n      background: #FFE7E2;\n    }\n    .cancelled::after{\n      box-shadow: -0.75rem 0 0 0 #FFE7E2;\n    }\n    .cancelled::before{\n      box-shadow: 0.75rem 0 0 0 #FFE7E2;\n    }\n    .re-initiated{\n      background: #DAFFF6;\n    }\n    .re-initiated::after{\n      box-shadow: -0.75rem 0 0 0 #DAFFF6;\n    }\n    .re-initiated::before{\n      box-shadow: 0.75rem 0 0 0 #DAFFF6;\n    }\n    .Value{\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 0.5rem;\n      width: 100%;\n      span{\n        font-size: clamp(0.75rem, 2vw, 1.5rem);\n        font-weight: 700;\n        color: var(--TextColor);\n        line-height: 100%;\n        min-height: clamp(0.75rem, 2vh, 2.25rem);\n      }\n      span:nth-child(2){\n        font-size: 0.75rem;\n        font-weight: 700;\n        color: var(--TextColor);\n        white-space: nowrap;\n      }\n    }\n  }\n  .Total{\n    background: var(--Background);\n    cursor: default;\n  }\n  .LoaderContainer{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    min-height: 3.75rem;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #2C2C2C50;\n    z-index: 3;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
